import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { DayOfWeek } from '../../../../../../common';

export function isWorkingHoursEmpty(): (formGroup: UntypedFormGroup) => ValidationErrors | null {
  return (formGroup: UntypedFormGroup): ValidationErrors | null => {
    let isValid = false;

    for (const day of Object.keys(DayOfWeek)) {
      const dayAsKey: string = day.toLowerCase();

      (formGroup.get(dayAsKey) as UntypedFormArray).controls.forEach((control: UntypedFormControl) => {
        const { start, end } = control.value;

        if (start && end) {
          isValid = true;
        }
      });

      if (isValid) {
        return null;
      }
    }

    return { workingHoursEmpty: true };
  };
}
